import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getDocumentsId } from "../../redux/actions/actionDocument";
import { getInDocuments } from "../../redux/actions/actioninDocument";
import DetailPDF from "./detailPDF";
import { format } from "date-fns";
// import {
//     Accordion,
//     AccordionItem,
//     AccordionItemHeading,
//     AccordionItemButton,
//     AccordionItemPanel,
// } from 'react-accessible-accordion';
import { FaAngleDown } from "react-icons/fa"
import InDocumentChild from "../InDocuments/inDocumetChild";
import { IdInDocument } from "../Contexts/contexts";
import Accordion from "../Accordion/accordion";

export default function DocumentsDetail() {
    
    const dispatch = useDispatch();
    const documents = useSelector(state => state.documents.documentsDetail)
    const inDocument = useSelector(state => state.inDocuments.allInDocuments)
    const [verPDF, setVerPDF] = useState(false)
    const { id } = useParams()

    useEffect(() => {
        dispatch(getDocumentsId(id));
        dispatch(getInDocuments());
    }, [dispatch, id]);

    const opendPDF = () => {
        setVerPDF(true)
      }   

    console.log(documents)
    console.log(inDocument)
    console.log(id)

    const inDocumentsFilter = inDocument.length > 0 ? inDocument[0].filter(e => e.document_id !== null ? e.document_id._id === id : null) : null;
    console.log(inDocumentsFilter)
    const lastInDocument = inDocumentsFilter && inDocumentsFilter[0]
    console.log(lastInDocument);
    
    return (
        <div className="container bg-gray-900">
                        
            <div className="container m-8 text-orange-500 text-[10pt] font-bold">                
                <div>
                <p className="text-xl pb-8 underline">Remitos - Detalle</p>
                </div>
                <div className="flex text-center">
                    <div className="w-32 bg-slate-700 hover:text-white border-2 border-black">
                    <Link to={`/documentos/modificar/${id}`}>
                        <p>Modificar</p>                        
                    </Link>
                    </div>
                    <div className="w-32 bg-slate-700 hover:text-white border-2 border-black">
                    <Link to={"/inDocument/saldar"} state={[documents, lastInDocument]}>                       
                        <p>Saldar Remito</p>
                    </Link>
                    </div>
                    <div className="w-32 bg-slate-700 hover:text-white border-2 border-black">
                    <Link to={`/documentos/delete/${id}`}>
                        <p>Eliminar</p>
                    </Link>
                    </div>
                </div>
                <div className="flex w-3/3 mt-6 border-b-2 border-slate-500 pb-2">
                    <p className="w-1/3">Documento N°: {documents.numberDocument}</p>
                    <p className="w-1/3">Fecha: {documents.createdAt ? format(new Date(documents.createdAt), "dd/MM/yyyy") : null} </p>
                    <p className="w-1/3">Estado: {documents.parcial === true ? "Parcial" : (documents.state === false ? "No Saldado" : "Saldado") }</p>
                </div>
                <div>
                    {documents.client_id === undefined ? (
                    <div className="w-full py-2 pb-2 border-b-2 border-slate-500">
                    <div className="flex">
                    <p className="w-1/4">Cliente N°:</p>
                    <p className="w-1/4">Compañia:</p>
                    <p className="w-1/4">Nombre:</p>
                    <p className="w-1/4">Apellido:</p>
                    </div>
                    <div className="flex">
                    <p className="w-1/4">Dirección:</p>
                    <p className="w-1/4">Ciudad:</p>
                    <p className="w-1/4">Telefonos:</p>
                    <p className="w-1/4">E-mail:</p>
                    </div>
                    </div>
                    ):(
                    <div className="w-full py-2 border-b-2 border-slate-500">
                    <div className="flex">    
                    <p className="w-1/4">Cliente N°: {documents.client_id.idClient}</p>
                    <p className="w-1/4">Compañia: {documents.client_id.nameCompany}</p>
                    <p className="w-1/4">Nombre: {documents.client_id.name}</p>
                    <p className="w-1/4">Apellido: {documents.client_id.lastName}</p>
                    </div>
                    <div className="flex">
                    <p className="w-1/4">Dirección: {documents.client_id.address}</p>
                    <p className="w-1/4">Ciudad: {documents.client_id.city}</p>
                    <p className="w-1/4">Telefonos: {documents.client_id.telephoneNumber}</p>
                    <p className="w-1/4">E-mail: {documents.client_id.email}</p>
                    </div>
                    </div>
                    )}
                </div>
                <div className="flex w-3/3 border-b-2 border-slate-500 py-2">
                    <p className="w-1/3">Dirección de Evento: {documents.addressEvent}</p>
                    <p className="w-1/3">Fecha de Envío: {documents.dateSend ? format(new Date(documents.dateSend), "dd/MM/yyyy") : null}</p>
                    <p className="w-1/3">Fecha de Recepción: {documents.dateReception ? format(new Date(documents.dateReception), "dd/MM/yyyy") : null}</p>
                </div>
                <div className="pt-4">
                    <p className="font-bold text-[12pt]">Artículos:</p>
                </div>
                <div className="flex w-full border-b-2 border-slate-500">
                    <p className="w-1/3">Nombre</p>
                    <p className="w-2/5">Descripción</p>
                    <p className="w-20 text-center">Cantidad</p>
                </div>
                <div>
                    {documents.quantityItems && documents.quantityItems.map(e=> {
                        return (
                            <div className="flex border-b-2 border-slate-500 text-[9pt]" key={e.item}>
                            <p className="w-1/3">{e.name}</p>
                            <p className="w-2/5">{e.descrip}</p>
                            <p className="w-20 text-center">{e.quantity}</p>
                            </div>
                        )
                    })
                    }
                </div>
                <div>
                    <Accordion 
                        titulo={<div className="flex flex-row mt-4">Documentos saldadores <FaAngleDown/></div>}
                        opciones={
                            <div>
                                {inDocumentsFilter && inDocumentsFilter.map((e, index)=> {
                                    return (
                                        <div key={index} className="min-w-full border-2 border-green-400 py-2 pl-2">
                                            <div className=""><p>Documento N° {e.numberDocument}</p></div>
                                            <div className="flex flex-row">
                                                            <div className="w-2/3">Art</div>
                                                            <div className="w-10">Cantidad</div>
                                                            </div>
                                            <div>
                                                {e.quantityItems.map(x=> {
                                                    return (
                                                        <div key={x.item}>                                                            
                                                            <div className="flex flex-row">
                                                            <div className="w-2/3">{x.name}</div>
                                                            <div className="w-10">{x.quantity}</div>
                                                            </div>                                                            
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                        }
                    />                  
                </div>
                <div>
                    <Accordion 
                        titulo={<div className="flex flex-row mt-3">Articulos Faltantes <FaAngleDown/></div>}
                        opciones={
                            <div>
                                {lastInDocument && lastInDocument.itemsMissing.map(e => {
                                    return (
                                    <div key={e.item} className="flex flex-row border-2 border-yellow-400 py-2 pl-2">
                                        <div className="w-2/3">{e.name}</div>
                                        <div className="w-10">{e.quantity}</div>
                                    </div>
                                )})}
                            </div>
                        }
                    />
                   {/* <Accordion allowZeroExpanded="true">
                        <AccordionItem>
                        <AccordionItemHeading>
                                <AccordionItemButton>
                                    <p className="flex flex-row mt-3">Articulos Faltantes <FaAngleDown/></p>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                {lastInDocument && lastInDocument.itemsMissing.map(e => {
                                    return (
                                    <div key={e.item} className="flex flex-row border-2 border-yellow-400 py-2 pl-2">
                                        <div className="w-2/3">{e.name}</div>
                                        <div className="w-10">{e.quantity}</div>
                                    </div>
                                )})}
                            </AccordionItemPanel>
                        </AccordionItem>                        
                   </Accordion>  */}
                </div>
                <div>
                <button className="mt-12 p-4 rounded bg-sky-500 text-white" onClick={opendPDF}>Ver PDF</button>
                </div>                
                <div>
          {verPDF ? (
            <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
              flex flex-col justify-center items-center">
              <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                <button className="text-black font-bold hover:text-white" onClick={()=> setVerPDF(false)}>Cerrar</button>
              </div>             
              <div>
                <DetailPDF
                  key={id} 
                  id={id}
                  document={documents}
                />
              </div>              
            </div>
          ) : null}
        </div>
            </div>
        </div>
    )
}